module.exports = __webpack_public_path__ + "static/media/maker.e09d33e2.svg";